// The mates on the open programme (#184), for slots deep in the timeline.
// { group, me } from ProgrammeView; null when it isn't shared.
import { createContext, useContext } from "react";

export const ProgrammeMatesContext = createContext(null);

export const useProgrammeMatesContext = () => useContext(ProgrammeMatesContext);
